import { useEffect, useState } from "react";
import { API } from "../../config/api";
import { GET, POST } from "../../utils/apicalls";
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Import for table generation in jsPDF
import { useParams } from "react-router-dom";
import PageHeader from "../pageHeader/pageheader";
import moment from "moment";
import DataTableMonthlyReport from "./dataTableMonthlyReport";
import CalenderMonthlyReport from "./calenderMonthlyReport";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  notification,
  Row,
  Select,
  Switch,
} from "antd";

function MonthlyReportIndex() {
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(10);
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [meta, setMeta] = useState<any>({});
  const [clientData, setClientData] = useState<any>({});
  const [isCalendarView, setIsCalendarView] = useState(false); // Toggle for Calendar View
  const { id } = useParams();
  const [form] = Form.useForm();
  const sortedData = data?.slice().sort((a: any, b: any) => {
    if (a.date && b.date) {
      return (
        moment(a.date).toDate().getTime() - moment(b.date).toDate().getTime()
      );
    }
    return a.date ? -1 : 1; // Ensure valid dates come before invalid ones
  });
  // Fetch Monthly Planner Data
  const fetchMonthlyPlanner = async (page: number, take: number) => {
    try {
      setIsLoading(true);
      const obj = {
        query: form.getFieldValue("query"),
        page,
        take,
        clientId: Number(id),
      };
      const url = API.LIST_MONTHLY_REPORT;
      const response: any = await POST(url, obj);
      setData(response?.data || []);
      setMeta(response?.meta || {});
    } catch (error) {
      console.log("Error fetching monthly planner data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const downloadPDFDocument = () => {
    const doc: any = new jsPDF();

    // Title
    doc.setFontSize(18);
    doc.text("Monthly Report", 14, 20);

    // Add the client's name below the title (you can adjust the Y position as needed)
    doc.setFontSize(14); // Use a smaller font size for the company name
    doc.text(clientData.companyName || "Client Name", 14, 30); // Fallback if company name is not available

    // Table headers
    const headers = [
      [
        "Date",
        "Poster Content",
        "Celebration Days",
        "Campaigns Content",
        "Impression",
        "Leads",
        "Amount",
        "Status",
      ],
    ];

    // Table rows
    const rows = sortedData?.map((item: any) => [
      item.date ? moment(item.date).format("DD/MM/YYYY") : "-",
      item.posterContent || "",
      item.celebrationDays || "",
      item.campaignsContent || "",
      item.impression || "",
      item.leads || "",
      item.amount || "",
      item.status || "",
    ]);

    // Add table to PDF
    doc.autoTable({
      head: headers,
      body: rows,
      startY: 40, // Adjusted to start below title and company name
      theme: "grid",
      styles: { fontSize: 10 },
    });

    // Save the PDF
    doc.save(`${clientData.companyName}.pdf`);
  };

  // Fetch Client Data on mount and whenever `id` or `data.clientId` is available
  useEffect(() => {
    getClientData();
  }, []);

  const getClientData = async () => {
    try {
      const api = `${API.CLIENT_GET_ONE}${id}`;
      const response: any = await GET(api, {});
      setClientData(response?.data || {});
      console.log("qwertyuiop====", response);
      form.setFieldsValue(response?.data);
    } catch (error) {
      console.log("Error fetching client data:", error);
    }
  };

  useEffect(() => {
    fetchMonthlyPlanner(page, take);
  }, [page, take]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };
  const submitHandler = async (values: any) => {
    try {
      let obj = {
        clientId: id,
        date: values.date,
        posterContent: values.posterContent,
        celebrationDays: values.celebrationDays,
        campaignsContent: values.campaignsContent,
        impression: values.impression,
        leads: values.leads,
        amount: values.amount,
        status: values.status,
      };

      setIsLoading(true);
      const api = API.CREATE_MONTHLY_REPORT;
      const postRequest: any = await POST(api, obj);

      if (postRequest.status) {
        notification.success({ message: "Report created successfully!" });
        setIsLoading(false);
        setIsModalOpen(false);
        form.resetFields();
        fetchMonthlyPlanner(page, take);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const months = [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];
  const search = async (values: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        clientId: Number(id),
        month: Number(values.month),
      };
      const url = API.SEARCH_MONTHLY_REPORT;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div>
      <PageHeader>
        <Button
          type="primary"
          onClick={showModal}
          style={{ marginRight: "10px" }}
        >
          Create Report
        </Button>
      </PageHeader>
      <Card>
        <Card>
          <Form form={form} onFinish={search} layout="vertical">
            <Row gutter={16}>
              <Col sm={6}>
                <Form.Item
                  label="Month"
                  name="month"
                  style={{ marginBottom: 10 }}
                >
                  <Select placeholder="Select a month" size="large" allowClear>
                    {months.map((month) => (
                      <Select.Option key={month.value} value={month.value}>
                        {month.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    block
                  >
                    search
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
        {/* Button to Download PDF Document */}
        <button
          onClick={downloadPDFDocument}
          style={{
            marginBottom: "20px",
            padding: "10px 20px",
            backgroundColor: "#1890ff",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Download Planner as PDF
        </button>

        {/* Toggle between Table and Calendar View */}
        <div style={{ marginBottom: "20px" }}>
          <label style={{ marginRight: "10px" }}>
            Switch to Calendar View:
          </label>
          <Switch checked={isCalendarView} onChange={setIsCalendarView} />
        </div>
        {/* Conditionally Render Table or Calendar View */}
        {isCalendarView ? (
          <CalenderMonthlyReport dataSource={data} />
        ) : (
          <DataTableMonthlyReport
            dataSource={data}
            isLoading={isLoading}
            meta={meta}
            onPageChange={(page: number, take: number) => {
              setIsLoading(true);
              setPage(page);
              setTake(take);
            }}
          />
        )}
      </Card>

      <Modal
        title="Create Report"
        visible={isModalOpen}
        onCancel={handleCancel}
        width={1000}
        footer={false}
      >
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Row gutter={16}>
            <Col sm={6}>
              <Form.Item
                name="date"
                label="date"
                rules={[{ required: true, message: "Select date" }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="posterContent"
                label=" posterContent"
                rules={[{ required: true, message: "Enter posterContent" }]}
              >
                <Input placeholder=" posterContent" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="celebrationDays"
                label="celebrationDays"
                rules={[{ required: true, message: "Enter celebrationDays" }]}
              >
                <Input placeholder="celebrationDays" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="campaignsContent"
                label="campaignsContent"
                rules={[{ required: true, message: "Enter campaignsContent" }]}
              >
                <Input placeholder="campaignsContent" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="impression"
                label="impression"
                rules={[{ required: true, message: "Enter impression" }]}
              >
                <InputNumber
                  placeholder="Impression"
                  style={{ width: "100%" }}
                  min={0}
                />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="leads"
                label="leads"
                rules={[{ required: true, message: "Enter leads" }]}
              >
                <InputNumber
                  placeholder="Leads"
                  style={{ width: "100%" }}
                  min={0}
                />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="amount"
                label="amount"
                rules={[{ required: true, message: "Enter amount" }]}
              >
                <InputNumber
                  placeholder="Amount"
                  style={{ width: "100%" }}
                  min={0}
                />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="status"
                label="status"
                rules={[{ required: true, message: "Enter status" }]}
              >
                <Input placeholder="status" />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  block
                >
                  Create Planner
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
}

export default MonthlyReportIndex;
